import '../App.scss';
import { Questionnaire } from '../components/questionnaire';
import { Button } from '@mui/base/Button';
import { useNavigate, useLocation } from 'react-router-dom';

function Questions() {
  const navigate = useNavigate();

   const handleBackToProjects = () => {
    navigate('/projects');
  };
  
  return (
    <div className="main pb-4 d-flex flex-column align-items-center">
      <div className="mb-3">
            <Button className="styled-button" onClick={handleBackToProjects}>
              Back to projects
            </Button>
        </div>
    <Questionnaire enabled={true} />
    </div>
  );
}

export default Questions;